<script lang="ts">
  import { createQuery } from '@tanstack/svelte-query';
  import { Plus, FileText, ArrowRight } from 'lucide-svelte';
  import { docsApi } from '$lib/api/docs';
  import { getErrorMessage } from '$lib/api/client';
  import { route } from '$lib/state/route.svelte';
  import { session } from '$lib/state/session.svelte';
  import { relTime } from '$lib/utils/format';
  import EmptyState from '$lib/components/ui/EmptyState.svelte';
  import DocModal from './DocModal.svelte';

  const { projectId }: { projectId: number } = $props();
  const admin = $derived(session.isAdmin);

  const docsQuery = createQuery(() => ({
    queryKey: ['project-docs', projectId],
    queryFn: () => docsApi.forProject(projectId)
  }));

  let showModal = $state(false);

  function openDoc(id: number) {
    route.push({ tab: 'doc', docId: id, back: route.current });
  }
</script>

{#if admin}
  <div style="display:flex;margin-bottom:16px">
    <div style="flex:1;font-size:13px;color:var(--t3)">
      {docsQuery.data?.results.length ?? 0} document{(docsQuery.data?.results.length ?? 0) !== 1 ? 's' : ''}
    </div>
    <button type="button" class="btn btn-secondary" onclick={() => (showModal = true)}><Plus size={16} />New doc</button>
  </div>
{/if}

{#if docsQuery.isLoading}
  <p style="color:var(--t3);font-size:13.5px">Loading docs…</p>
{:else if docsQuery.isError}
  <p style="color:var(--danger);font-size:13.5px">{getErrorMessage(docsQuery.error)}</p>
{:else if docsQuery.data?.results.length}
  <div class="list">
    {#each docsQuery.data.results as d (d.id)}
      <div class="card row-card" style="display:flex;align-items:center;gap:14px" onclick={() => openDoc(d.id)} role="button" tabindex="0" onkeydown={(e) => e.key === 'Enter' && openDoc(d.id)}>
        <div style="width:40px;height:40px;border-radius:10px;background:var(--surface-2);border:1px solid var(--border);display:flex;align-items:center;justify-content:center;color:var(--t3);flex-shrink:0">
          <FileText size={20} />
        </div>
        <div style="flex:1;min-width:0">
          <div class="rc-title">{d.title}</div>
          <div style="font-size:12px;color:var(--t3);margin-top:3px">Updated {relTime(d.updated_at)} · {d.updated_by}</div>
        </div>
        <ArrowRight size={18} />
      </div>
    {/each}
  </div>
{:else}
  <EmptyState
    icon={FileText}
    heading="No docs yet"
    sub={admin
      ? 'Write architecture notes, protocols and setup guides. Developers read them here.'
      : "The admin hasn’t published any docs for this project yet."}
  >
    {#snippet action()}
      {#if admin}
        <button type="button" class="btn btn-secondary" onclick={() => (showModal = true)}>New doc</button>
      {/if}
    {/snippet}
  </EmptyState>
{/if}

{#if showModal}
  <DocModal {projectId} doc={null} onClose={() => (showModal = false)} />
{/if}
